import basicController from 'servicestack/basic.controller.properties'
import templateUrl from 'emun.stockchecker/stock-checker-welcome.htm'
import $session from 'servicestack/session'

class StockCheckerWelcomeController {
    constructor($rootScope, $state, createAutoQuery, createServiceBus) {
        basicController(this)
        this.$state = $state;
        this.$session = $session;
    }
}

let StockCheckerWelcome = {
    controller: StockCheckerWelcomeController,
    require:{
        container: '^stockChecker'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

angular.module('emun.stockchecker').component('stockCheckerWelcome', StockCheckerWelcome);


